import React from 'react';
import TypedOrderForm from './TypedOrderForm';

/**
 * Create Digital Order (formerly "Create K.I.N.D. Order") — a thin configuration over
 * TypedOrderForm. Renamed on 2026-10-29 (Ariane): studio is a dropdown Remote / EB5 and
 * location a dropdown KIND / CGI / AI Production, so the lists read e.g. "CGI - Remote".
 * The order type stays 'kind' and groups stay "kind-N" in the database (shown as
 * "digital production - N", see formatGroupLabel).
 *
 * Clients come from the database (Settings → Order clients → KIND); the 26 entries that used to
 * be hardcoded here were seeded 1:1 (same slugs) so existing KIND bookings keep matching.
 */
export const KIND_ORDER_CONFIG = {
  orderType: 'kind',
  title: 'Create Digital Order',
  noun: 'Digital Order',
  buttonLabel: 'Create Digital Order',
  positions: [
    { value: 'Development', label: 'Development' },
    { value: 'AI Content Production', label: 'AI Content Production' },
    { value: 'Hair & Make-Up', label: 'Hair & Make-Up' },
    { value: 'Art Direktion', label: 'Art Direktion' },
    { value: 'Foto', label: 'Foto' },
    { value: 'Foto Assist', label: 'Foto Assist' },
    { value: 'Video', label: 'Video' },
    { value: 'Digi-OP', label: 'Digi-OP' },
    { value: 'Styling', label: 'Styling' },
    { value: 'Styling Assist', label: 'Styling Assist' },
    { value: 'LOGISTIK / WARENAUFBEREITUNG', label: 'LOGISTIK / WARENAUFBEREITUNG' },
    { value: 'PRODUCER', label: 'PRODUCER' },
    { value: 'Art Buying', label: 'Art Buying' },
    { value: 'Account Management', label: 'Account Management' },
    { value: 'Videoproducing', label: 'Videoproducing' },
    { value: 'Post Production', label: 'Post Production' },
    { value: '3D Artist', label: '3D Artist' },
    { value: 'Marketing I Sales 70440', label: 'Marketing I Sales 70440' },
        { value: 'Academy / Innovation Lab OSHH', label: 'Academy / Innovation Lab OSHH' },
  ],
  defaultPosition: 'AI Content Production',
  fixedPosition: false,
  // Studio dropdown (Remote preselected); `studio` is the fallback when no choice was made.
  studio: 'Remote',
  studios: [
    { value: 'remote', label: 'Remote' },
    { value: 'eb5', label: 'EB5' },
  ],
  // KIND resolves to the real location record; CGI and AI Production have no record and are
  // stored as a label string (the lists show the string as the location).
  locations: [
    { value: 'kind', label: 'KIND', match: ['K.I.N.D.'] },
    { value: 'cgi', label: 'CGI', match: [] },
    { value: 'ai_production', label: 'AI Production', match: [] },
  ],
  fixedLocation: false,
  set: 'digital Production',
  billing: ['daily', 'hourly', 'kpi'],
  infoLabel: 'Digital Info',
  infoPlaceholder: 'Digital-specific information (optional)',
  groupPrefix: 'kind',
};

function CreateKindOrder() {
  return <TypedOrderForm config={KIND_ORDER_CONFIG} />;
}

export default CreateKindOrder;
